(function() {

  "use strict";

  if (window.JuniorpodFixes) return;

  const config = window.JuniorpodFixConfig || {},

    PRODUCT_ID = Number(config.productId || 0xddb259b0130),

    PRODUCT_PATH = "products/kids-custom-printed-t-shirt",

    ROOT = window.Shopify?.routes?.root || "/",

    CATEGORY_FIELDS = Object.freeze({

      "Vehicle Garage": "Vehicles",

      "Animal Kingdom": "Animals",

      "Fruity Market": "Fruits",

      "Yummy Corner": "Food",

      "Sports Arena": "Sports",

      "Sports & Play": "Sports",

      "Water Animals": "Sea Animals",

      "Fantasy World": "Magic",

      "Gaming Arena": "Games",

      "Game Zone": "Games",

      "Under Water": "Sea Animals",

      "Colourful Wings": "Birds",

      "Space Station": "Space",

      "Flower Garden": "Flowers",

      "Magic & Fantasy": "Magic"

    }),

    trim = value => String(value ?? "").trim(),

    positiveInteger = value => Number.isInteger(Number(value)) && Number(value) > 0;

  let cart = null,

    readPending = null,

    scheduledRead = 0,

    frame = 0,

    lastCreation = "",

    busyAdd = !1,

    busyCheckout = !1,

    pendingAdd = null,

    giftDraft = "";

  const permittedClicks = new WeakSet,

    permittedForms = new WeakSet;

 

  function mainForm() {

    return Array.from(document.querySelectorAll(

      'form[id^="BuyButtons-ProductForm-"][action*="/cart/add"]')).find(form => {

      const productId = Array.from(form.elements).find(input => input.name ===

          "product-id")?.value || form.closest("product-form-component")?.dataset

        .productId;

      return Number(productId) === PRODUCT_ID || !productId && location.pathname

        .endsWith("/" + PRODUCT_PATH)

    }) || null

  }

 

  function propertyInputs(form, name) {

    if (!form) return [];

    const key = "properties[" + name + "]";

    return Array.from(form.elements).filter(input => (input.name === key || input.name ===

      key + "[]") && !input.disabled && (!["radio", "checkbox"].includes(input

      .type) || input.checked))

  }

 

  function property(form, name) {

    const values = [...new Set(propertyInputs(form, name).map(input => trim(input.value))

      .filter(Boolean))];

    return values.length === 1 ? values[0] : ""

  }

 

  function selectionScope(form) {

    return form?.closest(".shopify-section") || document.querySelector("#MainContent") ||

      document

  }

 

  function selectedImage(selector, scope, value) {

    const images = Array.from(scope.querySelectorAll(selector)).filter(image => !image

      .closest("#jpCreationRevealPopup"));

    return images.find(image => trim(image.alt) === value) || images[0] || null

  }

  // Resolve category relationships from Easify conditions, not display headings.

  function categoryField(theme) {

    const matches = new Set();

    const sets = window.TPOConfigs?.option_sets_searchable || [];

    for (const entry of sets) {

      const data = entry.data;

      const options = data?.options || [];

      const category = options.find(o =>

        o.option_identifier === "Pick Design Category");

      if (!category) continue;

      const choice = (category.option_types || []).find(o => trim(o.label) === theme);

      if (!choice) continue;

      for (const option of options) {

        if (option.type !== "image-swatches" || option === category) continue;

        let conditions;

        try {

          conditions = JSON.parse(option.conditions_serialized || "{}");

        } catch {

          continue;

        }

        if (conditions.action !== "SHOW") continue;

        const linked = (conditions.conditionOptions || []).some(rule =>

          String(rule.id).split(",")[0] === String(category.id) && ["EQUAL", "CONTAIN"]

          .includes(rule.relative) && String(rule.value) === String(choice.id));

        if (linked && trim(option.option_identifier)) {

          matches.add(trim(option.option_identifier));

        }

      }

    }

    if (matches.size === 1) return [...matches][0];

    if (matches.size > 1) return "";

    return CATEGORY_FIELDS[theme] || "";

  }

 

  function activeGroup(group) {

    if (!group || group.closest('[hidden], [aria-hidden="true"]')) return false;

    for (let node = group; node && node !== document.body; node = node.parentElement) {

      const style = getComputedStyle(node);

      if (style.display === "none" || style.visibility === "hidden") return false;

    }

    return true;

  }

 

  function rememberDesignField(state) {

    const form = mainForm();

    if (!form) return;

    const name = "properties[_Juniorpod Design Field]";

    let input = Array.from(form.elements).find(node => node.name === name);

    if (!input) {

      input = document.createElement("input");

      input.type = "hidden";

      input.name = name;

      form.appendChild(input);

    }

    const value = state.cartReady ? categoryField(state.theme) : "";

    if (input.value !== value) input.value = value;

    if (input.disabled !== !value) input.disabled = !value;

  }

 

  function readCreation() {

    const form = mainForm(),

      scope = selectionScope(form);

    const postedTheme = property(form, "Pick Design Category");

    const themeImages = Array.from(scope.querySelectorAll(

      ".po-polaroidOption-polaroidChecked img.po-polaroidOption-polaroidImage"

    )).filter(image => !image.closest("#jpCreationRevealPopup"));

    const themeImage = themeImages.length === 1 ? themeImages[0] : null;

    const theme = themeImage ? trim(themeImage.alt) : postedTheme;

    const field = categoryField(theme);

    const postedDesign = field ? property(form, field) : "";

    const groups = field ? Array.from(scope.querySelectorAll(".po-option-root"))

      .filter(group => activeGroup(group) &&

        Array.from(group.querySelectorAll("[name]")).some(input =>

          input.name === "properties[" + field + "]" ||

          input.name === "properties[" + field + "][]")) : [];

    // Some Easify versions keep submitted inputs outside their visible group.

    const titled = Array.from(scope.querySelectorAll(".po-option-root"))

      .filter(group => activeGroup(group) &&

        trim(group.querySelector(".po-label-labelContent")?.textContent) === theme);

    const inputGroup = field ? propertyInputs(form, field)[0]

      ?.closest(".po-option-root, .po-imageSwatches-root") : null;

    const group = groups.length === 1 ? groups[0] :

      activeGroup(inputGroup) ? inputGroup : titled.length === 1 ? titled[0] : null;

    const images = Array.from((group || scope).querySelectorAll(

      ".po-imageOption-checked img.po-imageOption-swatch"

    )).filter(image => !image.closest("#jpCreationRevealPopup") &&

      activeGroup(image.closest(".po-option-root")));

    // Never select an unrelated checked swatch left over in a hidden category.

    const exact = images.filter(image => trim(image.alt) === postedDesign);

    const designImage = exact.length === 1 ? exact[0] :

      group && images.length === 1 ? images[0] : null;

    const design = designImage ? trim(designImage.alt) : postedDesign;

    const size = scope.querySelector(

      'input[type="radio"][data-option-name="Size"]:checked');

    const colour = scope.querySelector(

      'input[type="radio"][data-option-name="Color"]:checked,' +

      'input[type="radio"][data-option-name="Colour"]:checked');

    const sizeValue = trim(size?.value),

      colorValue = trim(colour?.value);

    const themeValid = !!(field && theme && (!themeImage || theme === postedTheme));

    const designValid = !!(themeValid && design && designImage && design ===

    postedDesign);

    const ready = !!(form && sizeValue && colorValue && themeValid && designValid);

    let image = designValid ? designImage.currentSrc || designImage.src : "";

    if (image) try {

      const url = new URL(image, location.href);

      ["width", "height", "crop"].forEach(name => url.searchParams.delete(name));

      image = url.href;

    } catch {

      image = "";

    }

    return {

      size: sizeValue,

      color: colorValue,

      theme: themeValid ? theme : "",

      design: designValid ? design : "",

      image,

      ready,

      cartReady: ready

    };

  }

 

  function giftCheckbox() {

    return document.querySelector(

        'img.po-optionImageColor-image[alt="Make it a Gift Hamper"]')?.closest("label")

      ?.querySelector('input[type="checkbox"]') || null

  }

 

  function renderGiftMessage() {

    const wrapper = mainForm()?.querySelector("[data-jp-gift-message]"),

      input = wrapper?.querySelector("textarea");

    if (!input) return;

    input.dataset.jpInitialized || (input.value = giftDraft, input.dataset.jpInitialized =

      "true");

    const selected = !!giftCheckbox()?.checked;

    wrapper.hidden = !selected, input.disabled === selected && (input.disabled = !

      selected), updateText(wrapper.querySelector("[data-jp-gift-count]"), input.value

      .length + "/100 characters")

  }

 

  function includeGiftMessage(event) {

    if (event.target !== mainForm() || !event.formData) return;

    const input = event.target.querySelector("[data-jp-gift-message] textarea");

    if (!input) return;

    const value = giftCheckbox()?.checked ? input.value.trim().slice(0, 100) : "",

      key = "properties[Gift Message]";

    value ? event.formData.set(key, value) : event.formData.delete(key);

    const metadataKey = "properties[_po:items:properties]",

      metadata = event.formData.get(metadataKey);

    if (!(typeof metadata != "string" || !metadata)) try {

      const properties = JSON.parse(metadata);

      if (!properties || Array.isArray(properties) || typeof properties != "object")

        return;

      value ? properties["Gift Message"] = value : delete properties["Gift Message"],

        event.formData.set(metadataKey, JSON.stringify(properties))

    } catch {}

  }

 

  function isTee(item) {

    return Number(item.product_id) === PRODUCT_ID

  }

 

  function hasGift(item) {

    const props = item.properties || {};

    return Object.entries(props).some(([name, value]) => /^(make it a gift|gift hamper)$/i

      .test(trim(name)) && /make it a gift hamper|gift hamper/i.test(trim(value)))

  }

 

  function cartState(value) {

    const tees = (value?.items || []).filter(isTee);

    return {

      tees,

      count: tees.reduce((sum, item) => sum + Number(item.quantity || 0), 0),

      gift: tees.some(hasGift),

      giftUnits: tees.filter(hasGift).reduce((sum, item) => sum + Number(item.quantity ||

        0), 0)

    }

  }

 

  function cartIssue(value) {

    const state = cartState(value);

    for (const item of state.tees) {

      const props = item.properties || {},

        field = categoryField(trim(props["Pick Design Category"])) || trim(props[

          "_Juniorpod Design Field"]);

      if (!field || !trim(props[field]))

      return "A Creator Tee is missing its theme or design. Remove that item and create it again before checkout."

    }

    return state.giftUnits > 1 ?

      "Select the gift hamper on one T-shirt only. Add the second T-shirt separately without another hamper charge." :

      state.gift && state.count > 2 ?

      "One gift hamper holds at most 2 T-shirts. Reduce the Creator Tee quantity before checkout." :

      ""

  }

 

  function quantityIssue(value, item, nextQuantity) {

    if (!isTee(item)) return "";

    if (!Number.isInteger(nextQuantity) || nextQuantity < 0)

    return "Enter a whole-number quantity.";

    if (nextQuantity <= Number(item.quantity)) return "";

    if (hasGift(item) && nextQuantity > 1)

    return "Keep the gift-box T-shirt at quantity 1. Create the second T-shirt separately to avoid charging for another box.";

    const state = cartState(value);

    return state.gift && state.count - Number(item.quantity) + nextQuantity > 2 ?

      "Your gift hamper holds at most 2 T-shirts. You can reduce or remove items." : ""

  }

 

  function addIssue(value, quantity, giftSelected) {

    if (!positiveInteger(quantity)) return "Choose a valid quantity.";

    const state = cartState(value);

    return giftSelected && state.gift ?

      "A gift hamper is already included. Untick the gift hamper on this T-shirt." :

      giftSelected && quantity !== 1 ?

      "Add gift T-shirts one at a time. Select the hamper on the first T-shirt only." : (

        state.gift || giftSelected) && state.count + quantity > 2 ?

      "One gift hamper holds at most 2 T-shirts. Reduce the cart quantity or untick the gift hamper." :

      ""

  }

 

  function stop(event) {

    event.preventDefault(), event.stopImmediatePropagation()

  }

 

  function updateText(node, text) {

    node && node.textContent !== text && (node.textContent = text)

  }

 

  function message(text, context) {

    const host = context?.closest?.("form") || mainForm() || document.querySelector(

      "#MainContent");

    if (!host) return;

    let node = host.querySelector("[data-jp-fix-message]");

    node || (node = document.createElement("div"), node.className = "jp-fix-message", node

      .dataset.jpFixMessage = "", node.setAttribute("role", "alert"), node.tabIndex = -

      1, host.appendChild(node)), updateText(node, text), node.hidden = !text, text && (

      node.focus({

        preventScroll: !0

      }), node.scrollIntoView({

        behavior: "smooth",

        block: "nearest"

      }))

  }

 

  function creationIssue() {

    const state = readCreation();

    return !state.size || !state.color ? "Choose a size and colour first." : state.theme ?

      state.design ? state.cartReady ? "" :

      "Your design is still syncing. Please wait a moment, then tap Add to Cart again." :

      "Choose a design in your selected theme before adding your T-shirt." :

      "Choose a theme before adding your T-shirt."

  }

 

  function cartItemFor(input) {

    if (!cart || !input) return null;

    const key = input.closest("[data-key]")?.getAttribute("data-key");

    if (key) return cart.items.find(item => item.key === key) || null;

    const line = Number(input.getAttribute("data-cart-line"));

    return Number.isInteger(line) && line > 0 && cart.items[line - 1] || null

  }

 

  function cartQuantityEvent(event) {

    const detail = event.detail,

      line = Number(detail?.cartLine);

    if (!Number.isInteger(line) || line < 1 || !cart) return;

    const item = cart.items[line - 1];

    if (!item) return;

    const issue = quantityIssue(cart, item, Number(detail.quantity));

    if (!issue) {

      scheduleRead(650);

      return

    }

    stop(event);

    const input = document.querySelector('input[name="updates[]"][data-cart-line="' +

      line + '"]');

    input && (input.value = String(item.quantity)), message(issue, input)

  }

 

  function checkoutButtons() {

    return Array.from(document.querySelectorAll(

      'button[name="checkout"],input[name="checkout"],.jp-checkout-button'))

  }

 

  function renderCartActions() {

    if (!cart) return;

    const state = cartState(cart),

      issue = cartIssue(cart);

    checkoutButtons().forEach(button => {

      const parent = button.parentElement;

      if (!parent) return;

      let wrapper = Array.from(parent.children).find(el => el.hasAttribute(

        "data-jp-cart-action"));

      if (!wrapper) {

        wrapper = document.createElement("div"), wrapper.dataset.jpCartAction = "",

          wrapper.className = "jp-fix-cart-action";

        const note2 = document.createElement("p");

        note2.dataset.jpCartNote = "", note2.setAttribute("aria-live", "polite");

        const link = document.createElement("a");

        link.className = "jp-cart-next-btn", link.href = ROOT + PRODUCT_PATH, link

          .textContent = "CONTINUE SHOPPING \u2192", wrapper.append(note2, link),

          button.insertAdjacentElement("afterend", wrapper)

      }

      const note = wrapper.querySelector("[data-jp-cart-note]"),

        text = issue || (state.gift ? state.count < 2 ?

          "Your gift hamper has room for one more T-shirt." :

          "Your gift hamper contains 2 T-shirts." : "");

      updateText(note, text), note.hidden = !text, wrapper.classList.toggle(

        "jp-fix-cart-error", !!issue)

    });

    const box = giftCheckbox();

    if (box) {

      const label = box.closest("label");

      let note = label?.parentElement?.querySelector("[data-jp-gift-note]");

      !note && label && (note = document.createElement("p"), note.dataset.jpGiftNote = "",

        note.className = "jp-fix-gift-note", label.insertAdjacentElement("afterend",

          note)), updateText(note, state.gift ?

        "Gift hamper already included with your first T-shirt. Leave this option unticked." :

        ""), note && (note.hidden = !state.gift)

    }

  }

  async function readCart(force) {

    if (readPending && (await readPending, !force)) return cart;

    const task = (async () => {

      const response = await fetch(ROOT + "cart.js", {

        credentials: "same-origin",

        cache: "no-store",

        headers: {

          Accept: "application/json"

        }

      });

      if (!response.ok) throw new Error("Cart read failed: " + response.status);

      const value = await response.json();

      if (!Array.isArray(value.items)) throw new Error("Invalid cart response");

      return cart = value, scheduleRender(), value

    })();

    readPending = task;

    try {

      return await task

    } finally {

      readPending === task && (readPending = null)

    }

  }

 

  function scheduleRead(delay = 180) {

    clearTimeout(scheduledRead), scheduledRead = setTimeout(() => readCart(!0).catch(

  () => {}), delay)

  }

 

  function render() {

    frame = 0, renderGiftMessage();

    const state = readCreation();

    rememberDesignField(state);

    const signature = JSON.stringify(state);

    signature !== lastCreation && (lastCreation = signature, document.dispatchEvent(

      new CustomEvent("jp:creation:change", {

        detail: state

      }))), renderCartActions()

  }

 

  function scheduleRender() {

    frame || (frame = requestAnimationFrame(render))

  }

 

  function watchSuccessfulAdd(baseline, quantity) {

    const token = {};

    pendingAdd = token;

    let attempts = 0;

    const poll = async () => {

      if (pendingAdd === token) {

        attempts++;

        try {

          const value = await readCart(!0);

          if (cartState(value).count >= baseline + quantity) {

            pendingAdd = null, busyAdd = !1, window.location.assign(ROOT + "cart");

            return

          }

        } catch {}

        attempts < 12 ? setTimeout(poll, 700) : (pendingAdd = null, busyAdd = !1,

          message(

            "The cart addition was not confirmed. Check any product error and try again."

            ))

      }

    };

    setTimeout(poll, 450)

  }

  async function approveAdd(form, button, submitOnly) {

    if (busyAdd) return;

    const invalid = creationIssue();

    if (invalid) {

      message(invalid, form);

      return

    }

    busyAdd = !0;

    const signature = JSON.stringify(readCreation()),

      quantity = Number(form.elements.namedItem("quantity")?.value || 1),

      gift = !!giftCheckbox()?.checked;

    try {

      const value = await readCart(!0);

      if (form !== mainForm() || !form.isConnected || signature !== JSON.stringify(

          readCreation()) || quantity !== Number(form.elements.namedItem("quantity")

          ?.value || 1) || gift !== !!giftCheckbox()?.checked) {

        busyAdd = !1, message(

          "Your choices changed while checking the cart. Please tap Add to Cart again."

          );

        return

      }

      const issue = creationIssue() || addIssue(value, quantity, gift);

      if (issue) {

        busyAdd = !1, message(issue, form);

        return

      }

      if (button?.disabled) {

        busyAdd = !1;

        return

      }

      renderGiftMessage(), message("", form), permittedForms.add(form), button &&

        permittedClicks.add(button);

      try {

        submitOnly ? form.requestSubmit(button || void 0) : button.click()

      } finally {

        button && permittedClicks.delete(button), permittedForms.delete(form)

      }

      watchSuccessfulAdd(cartState(value).count, quantity)

    } catch {

      busyAdd = !1, message(

        "We could not check your cart. Please check your connection and try again.",

        form)

    }

  }

 

  function addButtonFor(target) {

    const button = target.closest?.('button,input[type="submit"]');

    if (!button || button.id === "jpAutoRevealButton") return null;

    const form = mainForm();

    if (!form) return null;

    if (button.form === form && (button.name === "add" || button.type === "submit"))

      return {

        button,

        form

      };

    if (button.closest("sticky-add-to-cart") || button.closest(

        '[aria-label="Quick add to cart bar"]')) {

      const primary = form.querySelector('button[type="submit"],input[type="submit"]');

      return primary ? {

        button: primary,

        form,

        sticky: !0

      } : null

    }

    return null

  }

  async function approveCheckout(button, form) {

    if (!busyCheckout) {

      busyCheckout = !0;

      try {

        const value = await readCart(!0),

          issue = cartIssue(value);

        if (issue) {

          message(issue, button || form);

          return

        }

        if (button && !button.isConnected) return;

        form && permittedForms.add(form), button && permittedClicks.add(button);

        try {

          button ? button.click() : form.requestSubmit()

        } finally {

          button && permittedClicks.delete(button), form && permittedForms.delete(form)

        }

      } catch {

        message("We could not verify the cart. Please try again.", button || form)

      } finally {

        busyCheckout = !1

      }

    }

  }

  window.addEventListener("click", event => {

    const target = event.target instanceof Element ? event.target : event.target

      ?.parentElement;

    if (!target) return;

    const button = target.closest('button,input[type="submit"]');

    if (button && permittedClicks.has(button)) return;

    const add = addButtonFor(target);

    if (add) {

      stop(event), approveAdd(add.form, add.button, !1);

      return

    }

    const checkout = target.closest(

      'button[name="checkout"],input[name="checkout"],.jp-checkout-button');

    if (checkout) {

      stop(event), approveCheckout(checkout, checkout.form || checkout.closest(

        "form"));

      return

    }

    const input = target.closest('button[name="plus"],button.quantity-plus')?.closest(

      "cart-quantity-selector-component,quantity-input,.quantity-selector,.quantity"

      )?.querySelector('input[name="updates[]"]');

    if (input) {

      const item = cartItemFor(input);

      if (!item) {

        stop(event), scheduleRead(0), message(

          "Checking the cart. Please try the quantity change again.", input);

        return

      }

      const issue = quantityIssue(cart, item, Number(input.value) + Number(input

        .step || 1));

      if (issue) {

        stop(event), message(issue, input);

        return

      }

    }

    target.closest(

      'cart-quantity-selector-component,cart-remove-button,[data-cart-remove],a[href*="/cart/change"]'

      ) && scheduleRead(600)

  }, !0), window.addEventListener("submit", event => {

    const form = event.target;

    if (!(!(form instanceof HTMLFormElement) || permittedForms.has(form))) {

      if (form === mainForm()) {

        stop(event), approveAdd(form, event.submitter || null, !0);

        return

      }(event.submitter?.name === "checkout" || /\/checkout(?:\?|$)/.test(form

        .action)) && (stop(event), approveCheckout(event.submitter || null, form))

    }

  }, !0);

 

  function guardQuantity(event) {

    const input = event.target;

    if (!(input instanceof HTMLInputElement) || input.name !== "updates[]" || event

      .type === "input" && input.value === "") return;

    const item = cartItemFor(input);

    if (!item) {

      scheduleRead(0);

      return

    }

    const issue = quantityIssue(cart, item, Number(input.value));

    issue ? (stop(event), input.value = String(item.quantity), message(issue, input)) :

      event.type !== "input" && scheduleRead(600)

  } ["input", "change", "blur"].forEach(name => window.addEventListener(name,

      guardQuantity, !0)), document.addEventListener("formdata", includeGiftMessage, !0),

    document.addEventListener("input", event => {

      event.target.matches?.("[data-jp-gift-message] textarea") && (giftDraft = event

        .target.value)

    }), window.addEventListener("quantity-selector:update", cartQuantityEvent, !0);

  let settleTimers = [];

 

  function settleSelection() {

    scheduleRender(), settleTimers.forEach(clearTimeout), settleTimers = [80, 250, 600,

      1200

    ].map(delay => setTimeout(scheduleRender, delay))

  } ["click", "change", "input", "pointerup", "touchend"].forEach(name => document

    .addEventListener(name, settleSelection, {

      capture: !0,

      passive: !0

    })), window.addEventListener("resize", settleSelection, {

    passive: !0

  }), document.addEventListener("visibilitychange", () => {

    document.hidden || settleSelection()

  }), ["cart:update", "cart:updated", "shopify:cart:lines-update",

    "shopify:cart:lines-add", "shopify:cart:lines-remove"

  ].forEach(name => document.addEventListener(name, event => {

    event.promise?.then ? event.promise.then(() => scheduleRead(30)).catch(() =>

      scheduleRead(30)) : scheduleRead(180)

  })), window.addEventListener("pageshow", () => {

    busyAdd = !1, busyCheckout = !1, pendingAdd = null, scheduleRender(),

      scheduleRead(0)

  });

  const api = {

    readCreation,

    getProductForm: mainForm,

    cartState,

    cartIssue,

    quantityIssue,

    addIssue,

    refresh: () => readCart(!0)

  };

  window.JuniorpodFixes = Object.freeze(api);

 

  function start() {

    new MutationObserver(scheduleRender).observe(document.body, {

      subtree: !0,

      childList: !0,

      attributes: !0,

      attributeFilter: ["class", "checked", "value", "aria-checked", "form", "name",

        "disabled", "alt", "src"

      ]

    }), (mainForm() || location.pathname.endsWith("/" + PRODUCT_PATH)) && setInterval(

    () => {

        document.hidden || scheduleRender()

      }, 500), scheduleRender(), scheduleRead(0)

  }

  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded",

  start, {

    once: !0

  }) : start()

})();

